export type MiscTaskTypeId = 'Admission Consents' | 'Other Documents';

/**
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
/**
 * Array of all MiscTaskTypeId values.
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
export const MISCTASKTYPEID_VALUES: readonly MiscTaskTypeId[] = [
  'Admission Consents',
  'Other Documents',
] as const;
